import { defineStore } from "pinia";
import { useTilesComposable } from "./tiles";

export const useTilesStore = defineStore("tiles", () => {
  const tiles = useTilesComposable();

  return {
    ...tiles
  };
});
